import { styled } from '@mui/system'
import { fontSizes, colors } from '../../Components/consts'
import { Tabs } from '../../Components/LazyComponents'

export const TabHeaderStyle = styled(Tabs)(({ theme }) => ({
  background: colors.gray.gray20,
  borderRadius: 5,
  '& .MuiTabs-indicator': {
    background: colors.text,
  },
  '& .MuiTab-textColorPrimary': {
    color: colors.gray.gray60,
    fontWeight: 500,
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .MuiTab-textColorPrimary.Mui-selected': {
    color: colors.text,
    fontWeight: 800,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .MuiTab-textColorInherit': {
    color: colors.yellow,
    fontWeight: 700,
  },
}))

export const InnerConStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  height: '75vh',
  '& .selectorRow': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    '& .selectorItem': {
      display: 'flex',
      flexDirection: 'column',
      margin: theme.spacing(1, 2),
      '& .selectorTitle': {
        fontSize: fontSizes.small,
        fontWeight: 600,
      },
    },
  },
}))

export const SpinnerCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
}))

type ContractYearProps = {
  color?: string
}
export const ContractYear = styled('td')<ContractYearProps>(({ color, theme }) => ({
  '& p': {
    color: color === 'green' ? colors.green : color === 'red' ? colors.red : colors.text,
  },
}))

export const TeamICCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& img': {
    height: 35,
    margin: 10,
    [theme.breakpoints.down('md')]: {
      height: 23,
      margin: 5,
    },
  },
}))

export const PlayerImgCon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  '& p': {
    color: colors.text,
    margin: theme.spacing(0, 1),
  },
  '& img': {
    borderRadius: '50%',
    height: 45,
    margin: theme.spacing(0, 1),
    [theme.breakpoints.down('md')]: {
      height: 25,
      margin: theme.spacing(0, 0.5),
    },
  },
}))

export const ResetBtn = styled('button')(({ theme }) => ({
  border: 'none',
  background: colors.lightestGrey,
  borderRadius: 10,
  cursor: 'pointer',
  marginLeft: 10,
  padding: theme.spacing(2),
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: colors.lightGrey,
  },
}))

export const ExlainerList = styled('ul')(({ theme }) => ({
  '& li': {
    color: colors.helperText,
    margin: theme.spacing(1, 0),
    fontSize: fontSizes.medium,
    fontWeight: 500,
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
      margin: theme.spacing(0.5, 0),
    },
  },
}))

export const ExplainerCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  margin: theme.spacing(2, 4),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(2),
  },
}))
